
const NavLink = ({ href, children }) => (
  <a
    href={href}
    className="text-blue-200 hover:text-white font-semibold px-3 py-1 transition-colors duration-200"
  >
    {children}
  </a>
);

export default NavLink;
